import React, { useEffect } from "react";
import _ from "lodash";

const TableBody = ({ data, columns, editMode, sortColumn }) => {
  const renderCell = (item, column, i) => {
    if (column.path === "id") return i + 1;

    if (editMode && column.input) return column.input(item);

    if (column.content) return column.content(item);

    return _.get(item, column.path);
  };

  const createKey = (item, column) => {
    return item.id + (column.path || column.key);
  };

  const renderRow = (item, i) => {
    return (
      <tr key={i}>
        {columns &&
          columns.map((column) => (
            <td key={createKey(item, column)}>{renderCell(item, column, i)}</td>
          ))}
      </tr>
    );
  };

  return <tbody>{data && data.map((item, i) => renderRow(item, i))}</tbody>;
};

export default TableBody;
